import { Component, computed, inject, input } from '@angular/core';
import { ScFieldValuePipe } from '@innogy/feh/shared';
import type { HomeBatteryCapacityAdviceRendering } from '@feh/homebattery-models';
import { TextInterpolationService } from '@core/jss-utils';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { HomebatteryUsageCapacityBreakdownComponent } from '../homebattery-capacity-breakdown/homebattery-usage-capacity-breakdown.component';

@Component({
  selector: 'wl-homebattery-capacity-advice-ui',
  standalone: true,
  templateUrl: './homebattery-capacity-advice-ui.component.html',
  imports: [
    HomebatteryUsageCapacityBreakdownComponent,
    ScFieldValuePipe,
    AutomationIdDirective,
  ],
})
export class HomebatteryCapacityAdviceUiComponent {
  public readonly rendering =
    input.required<HomeBatteryCapacityAdviceRendering>();
  public readonly energyCapacity = input.required<number | null>();

  private readonly interpolationService = inject(TextInterpolationService);

  protected readonly descriptionText = computed(() => {
    const energyCapacityValue = this.energyCapacity();
    if (energyCapacityValue === null) {
      return this.rendering().fields?.DescriptionTextVariant2;
    } else if (energyCapacityValue === 0 || energyCapacityValue > 15) {
      return this.rendering().fields?.DescriptionTextVariant3;
    } else {
      return this.interpolationService.interpolate(
        this.rendering().fields?.DescriptionText,
        {
          energyCapacity: this.energyCapacity() + 'kWh',
        },
        'plain_text'
      );
    }
  });
}
